
import Swal from 'sweetalert2';

const BASE_URL = 'https://crm-api.chaat.ly/api/v1';

const fetchData = async (
  endpoint,
  method = 'GET', // Default to GET method
  body,
  options = {}
) => {
  try {
    let TOKEN = '';
    if (typeof window !== 'undefined') {
      TOKEN = localStorage.getItem('access_token');
      // Check token expiration before making request
      const expiresAt = localStorage.getItem('token_expires_at');
      if (expiresAt && Date.now() > Number(expiresAt)) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        localStorage.removeItem('token_expires_at');
        window.location.href = '#/login';
        return;
      }
    }
    const url = `${BASE_URL}/${endpoint}`;
    console.log('Fetching URL:', url);
    var headers = {
      Accept: 'application/json',
    };

    if (TOKEN) {
      headers.Authorization = `Bearer ${TOKEN}`;
    }
    // Adjust headers: do NOT set JSON Content-Type for FormData or upload endpoints
    const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
    const isUploadEndpoint = endpoint === 'user/group/upload' || endpoint === 'support-requests/upload-file';
    if (!isFormData && !isUploadEndpoint) {
      headers = {
        ...headers,
        'Content-Type': 'application/json',
      };
      if (body && typeof body === 'object') {
        body = JSON.stringify(body);
      }
    }
    const response = await fetch(url, {
      method,
      headers,
      body,
      ...options,
    });

    if (!response.ok) {
      const error = await response.json();
      console.log('API Error:', error);
      if (
        error.error === "Invalid token" ||
        error.error === "Token has expired" ||
        error.error === "Not enough segments" ||
        error.error === "No authorization header found"
      ) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('token_expires_at');
        window.location.href = '#/login';
      }

      console.error('API Error:', error);
      showErrorToast(`Error: ${error.error || error.message || 'An error occurred'}`);
      throw error; // Throw the error so try/catch in components works
    }
    if (["POST", "PATCH", "PUT", "DELETE"].includes(method)) {
      showSuccessToast('Success: Request was successful');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

const showErrorToast = (message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  Toast.fire({
    icon: 'error',
    title: message,
  });
};

const showSuccessToast = (message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  Toast.fire({
    icon: 'success',
    title: message,
  });
};

export default fetchData;